export type ValidatorFn<T> = (item: unknown) => item is T;

export type ObjectValidator<T> = [T] extends [object]
	? [T] extends [unknown[]]
		? ValidatorFn<T>
		: { [key in keyof T]: ObjectValidator<T[key]> }
	: ValidatorFn<T>;
